export default "__VITE_ASSET__bc29757d__"